import { useEffect } from "react";
import Tealium, { EventLog } from "@4tn/webx-analytics";
import getPageCategory, { getRouteSlug } from "./getPageCategory";

const usePageView = (isLoading: boolean, data: unknown | undefined, error?: Error | null) => {
  useEffect(() => {
    if (isLoading || (data === undefined && !error)) return;
    if (EventLog.getLastEvent("view")?.page_url !== document.location.href) {
      const pageCategory = getPageCategory(document.location.pathname);
      const pageId = getRouteSlug(document.location.pathname);
      Tealium.view({ event_value: document.title, page_category: pageCategory, page_id: pageId });
    }
  }, [isLoading, data, error]);
};

export default usePageView;
